import React from 'react';
import {getHref} from '../../../../../../domain/utils/itemUtils';
import {useControllerProps, UseControllerPropsResult} from '../../../../../../domain/controllers/ControllerContext';
import {LineItemModel} from '../../../../../../domain/models/LineItem.model';

export enum ItemLinkDataHooks {
  Anchor = 'ItemLinkDataHooks.Anchor',
  NonClickableItem = 'ItemLinkDataHooks.NonClickableItem',
}

const handleClick = ({
  event,
  navigationStore,
  fullUrl,
  urlPart,
  useLinkFromCartItem,
}: {
  event: React.MouseEvent<HTMLAnchorElement>;
  navigationStore: UseControllerPropsResult['navigationStore'];
  fullUrl: string;
  urlPart?: string;
  useLinkFromCartItem: boolean;
}) => {
  event.preventDefault();
  event.stopPropagation();
  /* istanbul ignore else */
  if (useLinkFromCartItem || fullUrl) {
    return navigationStore.navigateToUrl(fullUrl);
  }
  /* istanbul ignore next */
  return navigationStore.navigateToProduct(urlPart);
};

export const ItemLink = ({
  lineItem,
  children,
  tabIndex,
}: {
  lineItem: LineItemModel;
  children: React.ReactChild;
  tabIndex?: number;
}) => {
  const {cartStore, navigationStore} = useControllerProps();
  const href = cartStore.useLinkFromCartItem ? lineItem.url.url : getHref(cartStore, lineItem);
  const shouldRenderNonClickableItem = cartStore.useLinkFromCartItem
    ? !href
    : Boolean(
        (!lineItem.url.relativePath || /* istanbul ignore next */ lineItem.url.relativePath === '') && !lineItem.url.url
      );

  if (shouldRenderNonClickableItem) {
    return <div data-hook={ItemLinkDataHooks.NonClickableItem}>{children}</div>;
  }

  return (
    <a
      href={href}
      onClick={(event) =>
        handleClick({
          event,
          navigationStore,
          fullUrl: lineItem.url.url,
          urlPart: lineItem.url.relativePath,
          useLinkFromCartItem: cartStore.useLinkFromCartItem,
        })
      }
      {...(tabIndex !== undefined ? {tabIndex} : {})}
      data-hook={ItemLinkDataHooks.Anchor}>
      {children}
    </a>
  );
};
